import { render, staticRenderFns } from "./UserFormNavigator.vue?vue&type=template&id=e513ebd4&scoped=true&"
import script from "./UserFormNavigator.vue?vue&type=script&lang=js&"
export * from "./UserFormNavigator.vue?vue&type=script&lang=js&"
import style0 from "./UserFormNavigator.vue?vue&type=style&index=0&id=e513ebd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e513ebd4",
  null
  
)

export default component.exports